{
  "seo": {
    "title": "Интеграции amoCRM — сайт, мессенджеры, телефония, 1С",
    "description": "Подключаем amoCRM к сайту, WhatsApp, Telegram, телефонии, 1С, маркетплейсам и десяткам сервисов. 70+ готовых интеграций: заявки, звонки и переписка в одной карточке сделки.",
    "keywords": "интеграции amoCRM, интеграция amoCRM с сайтом, интеграция amoCRM с 1С, WhatsApp amoCRM, телефония amoCRM, интеграция CRM",
    "canonicalPath": "/integrations"
  },
  "hero": {
    "badge": "{{count}} готовых интеграций",
    "title": "Интеграции **amoCRM**",
    "text": "Сводим заявки, звонки и переписку в amoCRM: менеджер работает из одной карточки, руководитель видит источники и SLA. Ниже — готовые сценарии, состав и цену согласуем под ваш бизнес процесс.",
    "primaryCta": {
      "label": "Обсудить интеграции",
      "href": "#lead"
    },
    "secondaryCta": {
      "label": "Смотреть каталог",
      "href": "#categories"
    },
    "stats": [
      {
        "value": "{{count}}+",
        "label": "Готовых интеграций"
      },
      {
        "value": "4",
        "label": "Категории каналов"
      },
      {
        "value": "от 15 мин",
        "label": "До первой заявки"
      },
      {
        "value": "100%",
        "label": "Заявок в одной воронке"
      }
    ]
  },
  "categories": [
    {
      "slug": "site-platforms",
      "title": "Сайт и площадки",
      "icon": "ri-global-line",
      "description": "Формы, корзины, маркетплейсы и почта — все входящие заявки попадают в amoCRM с источником, UTM-метками и ответственным."
    },
    {
      "slug": "messengers",
      "title": "Мессенджеры и боты",
      "icon": "ri-chat-3-line",
      "description": "WhatsApp, Telegram, VK и чат-боты: диалоги ведутся из карточки сделки, история переписки остается у команды."
    },
    {
      "slug": "telephony",
      "title": "Телефония",
      "icon": "ri-phone-line",
      "description": "Звонки, записи разговоров и коллтрекинг в сделке. Пропущенные звонки превращаются в задачи, РОП видит качество работы. В том числе звонки через мобильный  телефон и симкарту."
    },
    {
      "slug": "accounting",
      "title": "Учёт, запись и связки",
      "icon": "ri-links-line",
      "description": "1С, склад, аналитика, календари, рассылки, LMS, медицина и платежи — сшиваем CRM с вашим операционным контуром."
    }
  ],
  "items": [
    {
      "slug": "sajt",
      "icon": "ri-global-line",
      "title": "Интеграция с вашим сайтом",
      "shortDesc": "Формы, корзины и обратные звонки создают сделки с источником, UTM-метками и ответственным — без ручного переноса из почты.",
      "desc": "Подключаем сайт к amoCRM: Tilda, WordPress, Bitrix, OpenCart, кастомные сайты на React и Next.js. Каждая заявка попадает в CRM с UTM-метками, временем поступления и распределением по менеджерам. Настраиваем защиту от дублей, SLA первого ответа и передачу состава заказа.",
      "price": "от 5 000 ₽",
      "duration": "3–7 рабочих дней",
      "category": "site-platforms",
      "industries": [
        "E-commerce",
        "Недвижимость",
        "B2B-услуги"
      ],
      "related": [
        "avito",
        "envybox",
        "calltouch",
        "albato",
        "telegram"
      ],
      "faq": [
        {
          "q": "Какие CMS поддерживаете?",
          "a": "Tilda, WordPress, Bitrix, OpenCart, а также кастомные сайты на React/Next.js. Схема интеграции зависит от платформы: виджет, webhook или API."
        },
        {
          "q": "Сохраняются ли UTM-метки в сделке?",
          "a": "Да. utm_source, utm_medium, utm_campaign и остальные метки записываются в поля сделки — это основа сквозной аналитики."
        },
        {
          "q": "Можно ли передавать состав корзины?",
          "a": "Да, при интеграции интернет-магазина передаются позиции, сумма и контактные данные. Менеджер видит заказ прямо в карточке сделки."
        }
      ]
    },
    {
      "slug": "avito",
      "icon": "ri-store-2-line",
      "title": "Авито",
      "shortDesc": "Сообщения и звонки с Авито создают сделки с источником и ответственным — без ручного мониторинга личного кабинета, с автоматической квалификацией.",
      "desc": "Подключаем Авито через официальный API: новые сообщения и звонки по объявлениям автоматически создают сделки в amoCRM с указанием объявления, источника и ответственного менеджера. Команда перестает проверять кабинет площадки вручную. Возможно подключение ИИ робота для ответов согласно вашей базе знаний или каталога продукции.",
      "price": "от 12 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "site-platforms",
      "industries": [
        "Недвижимость",
        "Авто",
        "Услуги"
      ],
      "related": [
        "sajt",
        "cian",
        "telegram",
        "envybox"
      ],
      "faq": [
        {
          "q": "Нужен ли доступ к личному кабинету Авито?",
          "a": "Да, потребуется доступ к аккаунту для настройки API-интеграции. Пароль не хранится — используется токен с ограниченными правами."
        },
        {
          "q": "Различаются ли заявки по объявлениям?",
          "a": "Да, в сделке фиксируется, с какого объявления пришел лид — это позволяет считать эффективность каждого размещения."
        }
      ]
    },
    {
      "slug": "mailru",
      "icon": "ri-mail-line",
      "title": "Mail.ru Почта",
      "shortDesc": "Письма корпоративной почты Mail.ru в сделках amoCRM: история переписки у команды, без личных ящиков менеджеров.",
      "desc": "Корпоративная почта Mail.ru подключается к amoCRM через IMAP: входящие и исходящие письма автоматически привязываются к сделкам и контактам. История переписки доступна всей команде и не теряется при смене ответственного.",
      "price": "от 5 000 ₽",
      "duration": "2–4 рабочих дня",
      "category": "site-platforms",
      "industries": [
        "B2B-услуги",
        "E-commerce",
        "Производство"
      ],
      "related": [
        "gmail",
        "yandex-mail",
        "sajt"
      ],
      "faq": [
        {
          "q": "Работает ли с корпоративным доменом?",
          "a": "Да, поддерживаются ящики на собственном домене, размещенные в Mail.ru для бизнеса."
        },
        {
          "q": "Куда попадают письма от неизвестных адресов?",
          "a": "Система ищет контакт по email. Если контакт не найден — создает новую сделку или лид по правилу, которое вы задаете."
        }
      ]
    },
    {
      "slug": "gmail",
      "icon": "ri-mail-send-line",
      "title": "Gmail",
      "shortDesc": "Переписка из Gmail в карточке amoCRM: менеджер отвечает из CRM, история писем не теряется при смене ответственного.",
      "desc": "Двусторонняя синхронизация Gmail с amoCRM: письма подтягиваются в карточку сделки, а ответы можно отправлять прямо из CRM. Менеджеры работают в одном окне, а история переписки остается у компании.",
      "price": "от 5 000 ₽",
      "duration": "2–4 рабочих дня",
      "category": "site-platforms",
      "industries": [
        "B2B-услуги",
        "IT",
        "E-commerce"
      ],
      "related": [
        "mailru",
        "yandex-mail",
        "google-drive"
      ],
      "faq": [
        {
          "q": "Нужен ли Google Workspace?",
          "a": "Желательно для корпоративного контура, но поддерживаются и обычные Gmail-аккаунты через OAuth 2.0."
        },
        {
          "q": "Можно ли отправлять письма из CRM?",
          "a": "Да, письма уходят с вашего адреса, копия сохраняется в Gmail и в карточке сделки."
        }
      ]
    },
    {
      "slug": "yandex-mail",
      "icon": "ri-mail-open-line",
      "title": "Яндекс Почта",
      "shortDesc": "Переписка из Яндекс Почты в карточке amoCRM — удобно командам на Яндекс 360, история писем не теряется.",
      "desc": "Интеграция Яндекс Почты с amoCRM через IMAP и SMTP: вся переписка по клиенту собирается в карточке сделки. Подходит компаниям на Яндекс 360 — без пересылки писем и ручного копирования.",
      "price": "от 5 000 ₽",
      "duration": "2–4 рабочих дня",
      "category": "site-platforms",
      "industries": [
        "B2B-услуги",
        "Производство",
        "Услуги"
      ],
      "related": [
        "mailru",
        "gmail",
        "yandex-disk"
      ],
      "faq": [
        {
          "q": "Поддерживается ли Яндекс 360 для бизнеса?",
          "a": "Да, интеграция рассчитана в первую очередь на корпоративные ящики Яндекс 360."
        },
        {
          "q": "Сохраняются ли вложения?",
          "a": "Да, файлы из писем прикрепляются к сделке и доступны команде."
        }
      ]
    },
    {
      "slug": "cian",
      "icon": "ri-building-2-line",
      "title": "Циан",
      "shortDesc": "Обращения с Циан в amoCRM: звонки и заявки по объявлениям — риелтор не теряет лид в личном кабинете площадки.",
      "desc": "Заявки и звонки с Циан автоматически создают сделки в amoCRM с привязкой к объекту и объявлению. Риелтор работает в одной воронке, а руководитель видит, какие площадки реально приносят обращения.",
      "price": "от 15 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "site-platforms",
      "industries": [
        "Недвижимость"
      ],
      "related": [
        "avito",
        "sajt",
        "yclients"
      ],
      "faq": [
        {
          "q": "Передается ли информация об объекте?",
          "a": "Да, в сделку попадает ссылка на объявление и параметры объекта, если они есть в ответе площадки."
        },
        {
          "q": "Работает ли с несколькими аккаунтами?",
          "a": "Да, можно подключить несколько аккаунтов агентства и маркировать сделки по источнику."
        }
      ]
    },
    {
      "slug": "ozon",
      "icon": "ri-shopping-bag-3-line",
      "title": "Ozon",
      "shortDesc": "Заказы и обращения с Ozon в amoCRM — e-commerce видит продажи маркетплейса в общей воронке, а не только в кабинете Ozon.",
      "desc": "Интеграция с Ozon Seller API: заказы, отмены и обращения покупателей попадают в amoCRM. Селлер видит продажи маркетплейса рядом с другими каналами и считает unit-экономику в одной аналитике.",
      "price": "от 35 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "site-platforms",
      "industries": [
        "E-commerce"
      ],
      "related": [
        "sajt",
        "mojsklad",
        "1c"
      ],
      "faq": [
        {
          "q": "Какие данные передаются по заказам?",
          "a": "Номер заказа, состав, сумма, статус и данные пункта выдачи. Персональные данные покупателя передаются в рамках правил площадки."
        },
        {
          "q": "Можно ли связать с 1С и складом?",
          "a": "Да, Ozon часто связывают в единый контур с 1С и МойСклад — остатки и заказы синхронизируются."
        }
      ]
    },
    {
      "slug": "vk-forms",
      "icon": "ri-questionnaire-line",
      "title": "VK формы",
      "shortDesc": "Заявки из форм ВКонтакте в amoCRM — лид с источником и ответственным, без ручного переноса из кабинета VK.",
      "desc": "Заявки из VK-форм (Lead Ads и виджетов сообщества) автоматически создают сделки в amoCRM с указанием источника, кампании и ответственного. Маркетинг видит стоимость лида рядом с продажами.",
      "price": "от 5 000 ₽",
      "duration": "2–5 рабочих дней",
      "category": "site-platforms",
      "industries": [
        "E-commerce",
        "Услуги",
        "Образование"
      ],
      "related": [
        "vk-messages",
        "senler",
        "sajt"
      ],
      "faq": [
        {
          "q": "Нужен ли доступ к рекламному кабинету?",
          "a": "Да, для получения лидов через API потребуется доступ к сообществу и рекламному кабинету VK."
        },
        {
          "q": "Передаются ли UTM и название кампании?",
          "a": "Да, в сделке фиксируются источник, кампания и объявление — это позволяет считать окупаемость."
        }
      ]
    },
    {
      "slug": "envybox",
      "icon": "ri-customer-service-2-line",
      "title": "Envybox",
      "shortDesc": "Envybox и amoCRM: заявки с виджетов сайта в сделках — обратный звонок, квиз и чат без потерь между сервисами.",
      "desc": "Виджеты Envybox (обратный звонок, квиз, онлайн-чат) передают заявки в amoCRM мгновенно: с номером телефона, источником и страницей обращения. Менеджер получает лид в CRM, а не в почте.",
      "price": "от 20 000 ₽",
      "duration": "2–4 рабочих дня",
      "category": "site-platforms",
      "industries": [
        "Услуги",
        "E-commerce",
        "Недвижимость"
      ],
      "related": [
        "venyoo",
        "sajt",
        "calltouch"
      ],
      "faq": [
        {
          "q": "Какие виджеты поддерживаются?",
          "a": "Обратный звонок, квиз, чат и мультикнопка. Передача идет через webhook Envybox."
        },
        {
          "q": "Фиксируется ли страница, с которой пришла заявка?",
          "a": "Да, URL страницы записывается в поле сделки — удобно для анализа эффективности разделов сайта."
        }
      ]
    },
    {
      "slug": "venyoo",
      "icon": "ri-chat-1-line",
      "title": "Venyoo",
      "shortDesc": "Venyoo и amoCRM: заявки с виджетов сайта в сделках — обратный звонок и чат без ручного переноса из панели.",
      "desc": "Виджеты Venyoo передают обращения с сайта напрямую в amoCRM: обратный звонок, чат и формы. Заявка создается с источником и ответственным, а переписка сохраняется в карточке.",
      "price": "от 20 000 ₽",
      "duration": "2–4 рабочих дня",
      "category": "site-platforms",
      "industries": [
        "Услуги",
        "E-commerce",
        "Медицина"
      ],
      "related": [
        "envybox",
        "sajt",
        "telegram"
      ],
      "faq": [
        {
          "q": "Чем отличается от Envybox?",
          "a": "Функционально сервисы близки. Выбор зависит от вашего текущего виджета — интегрируем тот, которым вы пользуетесь."
        },
        {
          "q": "Сохраняется ли история чата?",
          "a": "Да, переписка прикрепляется к сделке и доступна команде."
        }
      ]
    },
    {
      "slug": "cdek",
      "icon": "ri-truck-line",
      "title": "СДЭК",
      "shortDesc": "СДЭК и amoCRM: заказы и статусы доставки в сделке — менеджер видит трек и этап отгрузки без кабинета СДЭК.",
      "desc": "Интеграция с API СДЭК: создание заказов на доставку из карточки сделки, автоматическое получение трек-номера и обновление статуса. Менеджер и клиент видят, где посылка, без ручного трекинга.",
      "price": "от 35 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "site-platforms",
      "industries": [
        "E-commerce",
        "Производство"
      ],
      "related": [
        "pochta-rossii",
        "mojsklad",
        "1c"
      ],
      "faq": [
        {
          "q": "Можно ли создавать заказ на доставку из CRM?",
          "a": "Да, карточка заказа в СДЭК создается прямо из сделки, трек-номер возвращается в CRM автоматически."
        },
        {
          "q": "Как обновляются статусы?",
          "a": "Через webhook СДЭК или периодический опрос API — статус в сделке меняется без участия менеджера."
        }
      ]
    },
    {
      "slug": "facebook-forms",
      "icon": "ri-feedback-line",
      "title": "Facebook формы",
      "shortDesc": "Лиды из Facebook Lead Ads в amoCRM — заявка с источником и ответственным, без ручного переноса из Meta.",
      "desc": "Facebook Lead Ads передают лиды в amoCRM через API: анкета, название кампании и объявления попадают в сделку. Маркетинг видит, какая креативная связка дает продажи, а не только клики.",
      "price": "от 25 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "site-platforms",
      "industries": [
        "E-commerce",
        "Образование",
        "Услуги"
      ],
      "related": [
        "facebook-messages",
        "sajt",
        "albato"
      ],
      "faq": [
        {
          "q": "Нужна ли верификация приложения?",
          "a": "Да, для доступа к Lead Ads API требуется приложение Meta и подтверждение прав. Мы берем эту часть на себя."
        },
        {
          "q": "Передаются ли поля анкеты?",
          "a": "Да, все поля формы маппятся в поля сделки или контакта amoCRM."
        }
      ]
    },
    {
      "slug": "pochta-rossii",
      "icon": "ri-mail-check-line",
      "title": "Почта России",
      "shortDesc": "Почта России и amoCRM: трек-номер и статус отправки в сделке — менеджер видит доставку без личного кабинета.",
      "desc": "Интеграция с API Почты России: создание отправления из сделки, получение трек-номера и отслеживание статусов. Клиент получает актуальную информацию, а менеджер не тратит время на ручной трекинг.",
      "price": "от 30 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "site-platforms",
      "industries": [
        "E-commerce",
        "Производство",
        "Логистика"
      ],
      "related": [
        "cdek",
        "mojsklad",
        "1c"
      ],
      "faq": [
        {
          "q": "Поддерживаются ли разные типы отправлений?",
          "a": "Да, посылки, бандероли и письма — тип выбирается при создании отправления из сделки."
        },
        {
          "q": "Как часто обновляется статус?",
          "a": "По расписанию (обычно каждые 2–4 часа) либо по webhook, если он доступен для вашего договора."
        }
      ]
    },
    {
      "slug": "whatsapp",
      "icon": "ri-whatsapp-line",
      "title": "WhatsApp",
      "shortDesc": "Диалоги из WhatsApp ведутся из amoCRM корпоративными каналами — история доступна команде и руководителю.",
      "desc": "Подключаем WhatsApp Business API к amoCRM: переписка ведется из карточки сделки, история сохраняется у компании, а не в телефоне менеджера. Поддерживаем официальный API и популярные шлюзы — подбираем вариант под ваши объемы.",
      "price": "от 20 000 ₽",
      "duration": "3–7 рабочих дней",
      "category": "messengers",
      "industries": [
        "E-commerce",
        "Медицина",
        "Услуги"
      ],
      "related": [
        "telegram",
        "radist",
        "umnico",
        "sajt"
      ],
      "faq": [
        {
          "q": "Официальный API или сторонний шлюз?",
          "a": "Зависит от задач. Официальный WhatsApp Business API надежнее и не нарушает правила, сторонние шлюзы дешевле на старте. Мы честно оцениваем риски каждого варианта."
        },
        {
          "q": "Сохраняется ли история при смене менеджера?",
          "a": "Да, вся переписка хранится в карточке сделки и доступна новому ответственному."
        },
        {
          "q": "Можно ли отправлять шаблонные сообщения?",
          "a": "Да, через утвержденные шаблоны — это требование WhatsApp для инициативных рассылок."
        }
      ]
    },
    {
      "slug": "telegram",
      "icon": "ri-telegram-line",
      "title": "Telegram",
      "shortDesc": "Обращения из Telegram попадают в сделку с ответственным и историей — без личных аккаунтов менеджеров.",
      "desc": "Интеграция Telegram с amoCRM: сообщения из бота или бизнес-аккаунта создают сделки и сохраняют переписку в карточке. Команда отвечает из CRM, а руководитель видит полный диалог, а не обрывки в личных чатах.",
      "price": "от 18 000 ₽",
      "duration": "2–5 рабочих дней",
      "category": "messengers",
      "industries": [
        "E-commerce",
        "Образование",
        "B2B-услуги"
      ],
      "related": [
        "whatsapp",
        "max",
        "salebot",
        "vk-messages"
      ],
      "faq": [
        {
          "q": "Бот или бизнес-аккаунт?",
          "a": "Возможны оба варианта: бот удобен для входящего потока и квалификации, бизнес-аккаунт — для живого общения менеджеров."
        },
        {
          "q": "Можно ли отправлять уведомления клиенту?",
          "a": "Да, из роботов amoCRM: статус заказа, напоминание о встрече, ссылка на оплату."
        }
      ]
    },
    {
      "slug": "max",
      "icon": "ri-message-2-line",
      "title": "MAX",
      "shortDesc": "Диалоги из мессенджера MAX попадают в сделку: история у команды, без личных аккаунтов менеджеров.",
      "desc": "Подключаем мессенджер MAX к amoCRM: входящие обращения создают сделки, переписка сохраняется в карточке. Клиенты пишут туда, где им удобно, а команда работает в едином окне CRM.",
      "price": "от 20 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "messengers",
      "industries": [
        "E-commerce",
        "Услуги",
        "Госсектор"
      ],
      "related": [
        "telegram",
        "whatsapp",
        "salebot"
      ],
      "faq": [
        {
          "q": "Что такое MAX?",
          "a": "Российский мессенджер с растущей аудиторией. Интеграция особенно актуальна для компаний, работающих с госсектором и B2C-аудиторией в РФ."
        },
        {
          "q": "Работает ли отправка из CRM?",
          "a": "Да, при наличии API у вашего аккаунта MAX — переписка двусторонняя."
        }
      ]
    },
    {
      "slug": "salebot",
      "icon": "ri-robot-line",
      "title": "Salebot",
      "shortDesc": "Боты Salebot квалифицируют лида и передают сделку в amoCRM с полями, тегами и ответственным.",
      "desc": "Salebot ведет диалог с клиентом в мессенджерах и передает в amoCRM готовую сделку: с заполненными полями, тегами и назначенным ответственным. Менеджер подключается, когда клиент уже прогрет и квалифицирован.",
      "price": "от 25 000 ₽",
      "duration": "3–7 рабочих дней",
      "category": "messengers",
      "industries": [
        "Образование",
        "Услуги",
        "E-commerce"
      ],
      "related": [
        "bothelp",
        "telegram",
        "whatsapp"
      ],
      "faq": [
        {
          "q": "Можно ли передавать результаты квиза?",
          "a": "Да, ответы бота маппятся в поля сделки — менеджер сразу видит потребность клиента."
        },
        {
          "q": "Что если бот не смог квалифицировать лида?",
          "a": "Сделка создается с тегом «требует внимания» и попадает на менеджера для ручного разбора."
        }
      ]
    },
    {
      "slug": "radist",
      "icon": "ri-chat-smile-3-line",
      "title": "Radist",
      "shortDesc": "Radist.online + amoCRM: WhatsApp и другие каналы в одной карточке сделки — переписка не теряется при смене менеджера.",
      "desc": "Radist.online собирает WhatsApp и другие каналы в единое окно и синхронизирует их с amoCRM. Вся переписка хранится в карточке сделки, а при смене ответственного новый менеджер видит полный контекст.",
      "price": "от 22 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "messengers",
      "industries": [
        "E-commerce",
        "Услуги",
        "Медицина"
      ],
      "related": [
        "whatsapp",
        "umnico",
        "pact"
      ],
      "faq": [
        {
          "q": "Какие каналы поддерживает Radist?",
          "a": "WhatsApp, Telegram, VK, Viber и виджеты сайта — набор зависит от вашего тарифа Radist."
        },
        {
          "q": "Где хранится переписка?",
          "a": "И в Radist, и в карточке сделки amoCRM — история не теряется при отключении сотрудника."
        }
      ]
    },
    {
      "slug": "bothelp",
      "icon": "ri-robot-2-line",
      "title": "BotHelp",
      "shortDesc": "BotHelp + amoCRM: боты в мессенджерах создают сделки с полями и ответственным — без ручного переноса из чата.",
      "desc": "BotHelp строит сценарии в мессенджерах и передает в amoCRM заполненную сделку. Автоматизация квалификации, рассылки и воронки прогрева — менеджер получает лид с контекстом диалога.",
      "price": "от 25 000 ₽",
      "duration": "3–7 рабочих дней",
      "category": "messengers",
      "industries": [
        "Образование",
        "Услуги",
        "E-commerce"
      ],
      "related": [
        "salebot",
        "telegram",
        "vk-messages"
      ],
      "faq": [
        {
          "q": "Передается ли история диалога?",
          "a": "Да, ключевые ответы и ссылка на диалог прикрепляются к сделке."
        },
        {
          "q": "Можно ли сегментировать базу?",
          "a": "Да, по тегам и полям из бота — удобно для рассылок и повторных касаний."
        }
      ]
    },
    {
      "slug": "senler",
      "icon": "ri-notification-3-line",
      "title": "Senler",
      "shortDesc": "Senler и amoCRM: подписчики VK и боты создают сделки — менеджер дожимает без ручного переноса из сообщества.",
      "desc": "Senler собирает подписчиков VK и запускает цепочки сообщений, а горячие лиды передаются в amoCRM. Менеджер видит, кто отреагировал на рассылку, и дожимает клиента в привычной воронке.",
      "price": "от 25 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "messengers",
      "industries": [
        "E-commerce",
        "Образование",
        "Услуги"
      ],
      "related": [
        "vk-messages",
        "vk-forms",
        "bothelp"
      ],
      "faq": [
        {
          "q": "Как определить горячего подписчика?",
          "a": "По реакции на рассылку и ответам в цепочке — вы задаете условия, при которых создается сделка."
        },
        {
          "q": "Нужна ли лицензия Senler?",
          "a": "Да, действующий тариф Senler с доступом к API."
        }
      ]
    },
    {
      "slug": "vk-messages",
      "icon": "ri-message-3-line",
      "title": "VK сообщения",
      "shortDesc": "Переписка VK в amoCRM: диалоги в карточке сделки — история у команды, без личных аккаунтов менеджеров.",
      "desc": "Сообщения сообщества ВКонтакте попадают в amoCRM: диалог сохраняется в карточке сделки, отвечать можно прямо из CRM. История остается у компании при смене менеджера.",
      "price": "от 20 000 ₽",
      "duration": "2–4 рабочих дня",
      "category": "messengers",
      "industries": [
        "E-commerce",
        "Услуги",
        "Образование"
      ],
      "related": [
        "vk-forms",
        "senler",
        "telegram"
      ],
      "faq": [
        {
          "q": "Нужны ли права администратора сообщества?",
          "a": "Да, для подключения потребуется токен сообщества с правами на сообщения."
        },
        {
          "q": "Работает ли с несколькими сообществами?",
          "a": "Да, можно подключить несколько сообществ и маркировать сделки по источнику."
        }
      ]
    },
    {
      "slug": "umnico",
      "icon": "ri-wechat-line",
      "title": "Umnico",
      "shortDesc": "Umnico и amoCRM: WhatsApp, VK и другие каналы в одной карточке — переписка не теряется при смене менеджера.",
      "desc": "Umnico объединяет мессенджеры и соцсети в одном окне и синхронизирует диалоги с amoCRM. Все обращения по клиенту собираются в сделке — команда видит полный контекст общения.",
      "price": "от 22 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "messengers",
      "industries": [
        "E-commerce",
        "Услуги",
        "Медицина"
      ],
      "related": [
        "radist",
        "pact",
        "whatsapp"
      ],
      "faq": [
        {
          "q": "Чем Umnico отличается от Radist?",
          "a": "Набор каналов и интерфейс близки. Обычно выбирают тот сервис, который уже используется в компании — интегрируем без миграции."
        },
        {
          "q": "Передаются ли теги и источник?",
          "a": "Да, канал и источник фиксируются в сделке для аналитики."
        }
      ]
    },
    {
      "slug": "suvvy",
      "icon": "ri-chat-2-line",
      "title": "Suvvy",
      "shortDesc": "Suvvy и amoCRM: AI-бот квалифицирует лида в мессенджере и создает сделку — менеджер подключается с готовым контекстом.",
      "desc": "Suvvy — AI-ассистент, который ведет диалог в мессенджере, отвечает на вопросы и квалифицирует клиента. Готовая сделка с саммари диалога попадает в amoCRM, менеджер продолжает с полным контекстом.",
      "price": "от 25 000 ₽",
      "duration": "3–7 рабочих дней",
      "category": "messengers",
      "industries": [
        "E-commerce",
        "Услуги",
        "Образование"
      ],
      "related": [
        "salebot",
        "chatgpt",
        "telegram"
      ],
      "faq": [
        {
          "q": "Что получает менеджер?",
          "a": "Сделку с заполненными полями и кратким саммари диалога — не нужно перечитывать всю переписку."
        },
        {
          "q": "Можно ли обучить бота на базе знаний?",
          "a": "Да, Suvvy использует вашу базу знаний и скрипты продаж."
        }
      ]
    },
    {
      "slug": "pact",
      "icon": "ri-message-line",
      "title": "Pact",
      "shortDesc": "Pact и amoCRM: WhatsApp и мессенджеры в карточке сделки — переписка не теряется при смене менеджера.",
      "desc": "Pact подключает WhatsApp и другие мессенджеры к amoCRM: диалоги ведутся из карточки, история сохраняется у компании. Подходит командам, которым важен контроль качества общения.",
      "price": "от 22 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "messengers",
      "industries": [
        "E-commerce",
        "Услуги",
        "B2B-услуги"
      ],
      "related": [
        "radist",
        "umnico",
        "whatsapp"
      ],
      "faq": [
        {
          "q": "Какие каналы поддерживаются?",
          "a": "WhatsApp в первую очередь, а также другие мессенджеры в зависимости от тарифа Pact."
        },
        {
          "q": "Можно ли контролировать качество ответов?",
          "a": "Да, история диалогов в сделке доступна руководителю для выборочной проверки."
        }
      ]
    },
    {
      "slug": "facebook-messages",
      "icon": "ri-messenger-line",
      "title": "Facebook сообщения",
      "shortDesc": "Переписка Facebook Messenger в amoCRM: диалоги в карточке сделки — история у команды, без личных аккаунтов.",
      "desc": "Сообщения Facebook Messenger попадают в amoCRM: диалог по клиенту сохраняется в сделке и доступен команде. Менеджеры отвечают из CRM, а не из личных аккаунтов.",
      "price": "от 25 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "messengers",
      "industries": [
        "E-commerce",
        "Услуги"
      ],
      "related": [
        "facebook-forms",
        "telegram",
        "umnico"
      ],
      "faq": [
        {
          "q": "Нужна ли страница Facebook?",
          "a": "Да, интеграция работает через страницу компании и права приложения Meta."
        },
        {
          "q": "Сохраняется ли история при смене менеджера?",
          "a": "Да, вся переписка остается в карточке сделки."
        }
      ]
    },
    {
      "slug": "telefoniya",
      "icon": "ri-phone-line",
      "title": "IP-телефония",
      "shortDesc": "Входящие и исходящие звонки фиксируются в сделке: запись разговора, автозадачи по пропущенным, аналитика для РОПа.",
      "desc": "Подключаем облачную АТС к amoCRM: при звонке автоматически открывается карточка клиента, запись разговора сохраняется в сделке, а пропущенный звонок создает задачу на перезвон. РОП видит количество и качество звонков по каждому менеджеру.",
      "price": "от 22 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "telephony",
      "industries": [
        "B2B-услуги",
        "E-commerce",
        "Медицина"
      ],
      "related": [
        "sipuni",
        "mango",
        "beeline",
        "speech-analytics"
      ],
      "faq": [
        {
          "q": "С какой АТС работает интеграция?",
          "a": "С большинством популярных: Sipuni, Mango Office, OnlinePBX, Zadarma, UIS, а также с операторскими АТС (МТС, Билайн, МегаФон, Теле2)."
        },
        {
          "q": "Создаются ли задачи по пропущенным?",
          "a": "Да, автоматически — с дедлайном и ответственным, чтобы лид не остыл."
        },
        {
          "q": "Хранятся ли записи разговоров?",
          "a": "Да, запись прикрепляется к сделке и доступна руководителю для контроля качества."
        }
      ]
    },
    {
      "slug": "beeline",
      "icon": "ri-phone-find-line",
      "title": "Билайн",
      "shortDesc": "Звонки Билайн Бизнес в amoCRM: карточка при звонке, запись в сделке, задачи по пропущенным.",
      "desc": "Телефония Билайн Бизнес интегрируется с amoCRM: входящий звонок открывает карточку клиента, запись сохраняется в сделке, пропущенные превращаются в задачи. Единый контур для отдела продаж.",
      "price": "от 22 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "telephony",
      "industries": [
        "B2B-услуги",
        "Услуги",
        "Производство"
      ],
      "related": [
        "telefoniya",
        "mts",
        "megafon"
      ],
      "faq": [
        {
          "q": "Нужен ли дополнительный сервис?",
          "a": "Обычно достаточно API Билайн Бизнес и настроек amoCRM — промежуточный сервис не требуется."
        },
        {
          "q": "Работает ли с несколькими номерами?",
          "a": "Да, все номера можно привязать к одной воронке или развести по отделам."
        }
      ]
    },
    {
      "slug": "sipuni",
      "icon": "ri-phone-check-line",
      "title": "Sipuni",
      "shortDesc": "Sipuni + amoCRM: коллтрекинг, записи и сделки из звонков без ручного учёта в Excel.",
      "desc": "Интеграция Sipuni с amoCRM: звонки фиксируются в сделках, записи разговоров сохраняются, коллтрекинг подставляет источник обращения. Пропущенные звонки создают задачи на перезвон.",
      "price": "от 22 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "telephony",
      "industries": [
        "B2B-услуги",
        "E-commerce",
        "Недвижимость"
      ],
      "related": [
        "telefoniya",
        "calltouch",
        "comagic"
      ],
      "faq": [
        {
          "q": "Поддерживается ли коллтрекинг?",
          "a": "Да, Sipuni передает источник звонка, что позволяет связать рекламу с продажами."
        },
        {
          "q": "Что с внутренними звонками?",
          "a": "Их можно исключить из аналитики, чтобы не искажать статистику."
        }
      ]
    },
    {
      "slug": "uis",
      "icon": "ri-phone-lock-line",
      "title": "UIS",
      "shortDesc": "UIS (Юис) и amoCRM: звонки, записи и коллтрекинг в одной карточке сделки.",
      "desc": "UIS подключается к amoCRM: звонки и записи разговоров сохраняются в сделке, работает коллтрекинг с подстановкой источника. Менеджер видит историю общения, РОП — статистику.",
      "price": "от 25 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "telephony",
      "industries": [
        "B2B-услуги",
        "Услуги",
        "Производство"
      ],
      "related": [
        "telefoniya",
        "sipuni",
        "mango"
      ],
      "faq": [
        {
          "q": "Есть ли умная маршрутизация?",
          "a": "Да, UIS умеет распределять звонки по правилам — интеграция сохраняет эту логику и передает результат в CRM."
        },
        {
          "q": "Хранятся ли записи в CRM?",
          "a": "Да, ссылка на запись прикрепляется к сделке."
        }
      ]
    },
    {
      "slug": "megafon",
      "icon": "ri-smartphone-line",
      "title": "МегаФон",
      "shortDesc": "Телефония МегаФон в amoCRM: звонки в сделках, записи разговоров, задачи по пропущенным.",
      "desc": "МегаФон Бизнес подключается к amoCRM через API: звонки фиксируются в сделках, записи сохраняются, пропущенные создают задачи. Единый контур для распределенных команд.",
      "price": "от 22 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "telephony",
      "industries": [
        "B2B-услуги",
        "Услуги",
        "Логистика"
      ],
      "related": [
        "telefoniya",
        "beeline",
        "mts"
      ],
      "faq": [
        {
          "q": "Нужна ли отдельная лицензия?",
          "a": "Нет, достаточно действующего договора на телефонию МегаФон Бизнес."
        },
        {
          "q": "Работает ли с виртуальной АТС?",
          "a": "Да, интеграция поддерживает облачную АТС МегаФона."
        }
      ]
    },
    {
      "slug": "zadarma",
      "icon": "ri-phone-fill",
      "title": "Zadarma",
      "shortDesc": "Zadarma + amoCRM: звонки в сделках, записи, пропущенные с задачей на перезвон.",
      "desc": "Zadarma интегрируется с amoCRM: входящие и исходящие звонки фиксируются в сделках, записи сохраняются, а пропущенные создают задачу. Бюджетное решение для небольшого отдела продаж.",
      "price": "от 20 000 ₽",
      "duration": "2–4 рабочих дня",
      "category": "telephony",
      "industries": [
        "Услуги",
        "B2B-услуги",
        "E-commerce"
      ],
      "related": [
        "telefoniya",
        "onlinepbx",
        "sipuni"
      ],
      "faq": [
        {
          "q": "Подходит ли для старта?",
          "a": "Да, Zadarma — один из самых бюджетных вариантов облачной телефонии."
        },
        {
          "q": "Есть ли запись разговоров?",
          "a": "Да, запись прикрепляется к сделке."
        }
      ]
    },
    {
      "slug": "mango",
      "icon": "ri-headphone-line",
      "title": "Mango Office",
      "shortDesc": "Mango Office + amoCRM: звонки, записи и пропущенные в сделке — классика IP-телефонии для отдела продаж.",
      "desc": "Mango Office — одна из самых распространенных АТС в РФ. Интеграция с amoCRM: карточка клиента при звонке, запись в сделке, задачи по пропущенным, статистика по менеджерам.",
      "price": "от 22 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "telephony",
      "industries": [
        "B2B-услуги",
        "E-commerce",
        "Производство"
      ],
      "related": [
        "telefoniya",
        "sipuni",
        "uis"
      ],
      "faq": [
        {
          "q": "Есть ли готовый коннектор?",
          "a": "Да, Mango Office имеет официальную интеграцию с amoCRM — мы настраиваем и адаптируем ее под процессы."
        },
        {
          "q": "Можно ли видеть загрузку менеджеров?",
          "a": "Да, по отчетам звонков в CRM и в кабинете Mango."
        }
      ]
    },
    {
      "slug": "onlinepbx",
      "icon": "ri-customer-service-line",
      "title": "OnlinePBX",
      "shortDesc": "OnlinePBX + amoCRM: звонки и записи в сделке, пропущенные с задачей — удобно для облачных АТС и распределённых команд.",
      "desc": "OnlinePBX подключается к amoCRM: звонки сохраняются в сделках с записями, пропущенные создают задачи, работает распределение по менеджерам. Хорошо подходит распределенным командам.",
      "price": "от 20 000 ₽",
      "duration": "2–4 рабочих дня",
      "category": "telephony",
      "industries": [
        "B2B-услуги",
        "E-commerce",
        "Услуги"
      ],
      "related": [
        "telefoniya",
        "zadarma",
        "mango"
      ],
      "faq": [
        {
          "q": "Поддерживаются ли распределенные офисы?",
          "a": "Да, OnlinePBX — облачная АТС, филиалы подключаются без дополнительного оборудования."
        },
        {
          "q": "Есть ли коллтрекинг?",
          "a": "Да, доступен и передается в CRM при настройке."
        }
      ]
    },
    {
      "slug": "mts",
      "icon": "ri-phone-line",
      "title": "МТС",
      "shortDesc": "Телефония МТС в amoCRM: звонки в сделках, записи, задачи по пропущенным — единый контур для отдела продаж.",
      "desc": "МТС Облачная АТС интегрируется с amoCRM: звонки фиксируются в сделках, записи сохраняются, пропущенные создают задачи. Единый контур с мобильной связью и CRM.",
      "price": "от 20 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "telephony",
      "industries": [
        "B2B-услуги",
        "Услуги",
        "Логистика"
      ],
      "related": [
        "telefoniya",
        "beeline",
        "megafon"
      ],
      "faq": [
        {
          "q": "Нужен ли номер МТС?",
          "a": "Да, интеграция работает с номерами, подключенными к МТС Облачной АТС."
        },
        {
          "q": "Можно ли объединить с другими операторами?",
          "a": "Да, в одной CRM можно свести несколько операторов."
        }
      ]
    },
    {
      "slug": "tele2",
      "icon": "ri-smartphone-line",
      "title": "Теле2",
      "shortDesc": "Телефония Теле2 в amoCRM: звонки в сделках, записи, задачи по пропущенным — единый контур для отдела продаж.",
      "desc": "Теле2 Бизнес подключается к amoCRM: звонки сохраняются в сделках с записями, пропущенные создают задачи на перезвон. Подходит компаниям, уже работающим на Теле2.",
      "price": "от 20 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "telephony",
      "industries": [
        "B2B-услуги",
        "Услуги"
      ],
      "related": [
        "telefoniya",
        "mts",
        "beeline"
      ],
      "faq": [
        {
          "q": "Какие функции доступны?",
          "a": "Фиксация звонков, записи, задачи по пропущенным, статистика по менеджерам."
        },
        {
          "q": "Поддерживается ли переадресация?",
          "a": "Да, логика переадресации Теле2 сохраняется, результат передается в CRM."
        }
      ]
    },
    {
      "slug": "comagic",
      "icon": "ri-advertisement-line",
      "title": "Comagic",
      "shortDesc": "Comagic (КoMagic) передаёт звонки, записи и источник в amoCRM — менеджер видит канал, РОП сверяет рекламу с сделками.",
      "desc": "Comagic — система коллтрекинга: определяет источник звонка и передает его в amoCRM вместе с записью. РОП видит, какой рекламный канал принес звонок и чем он закончился.",
      "price": "от 25 000 ₽",
      "duration": "3–7 рабочих дней",
      "category": "telephony",
      "industries": [
        "E-commerce",
        "Услуги",
        "Недвижимость"
      ],
      "related": [
        "calltouch",
        "roistat",
        "sipuni"
      ],
      "faq": [
        {
          "q": "Чем Comagic отличается от Calltouch?",
          "a": "Функционально близки, оба — коллтрекинг. Выбираем тот, что уже используется в вашей рекламе."
        },
        {
          "q": "Передаются ли UTM-метки?",
          "a": "Да, Comagic связывает звонок с источником и передает метки в сделку."
        }
      ]
    },
    {
      "slug": "speech-analytics",
      "icon": "ri-mic-line",
      "title": "Speech Analytics",
      "shortDesc": "Speech Analytics и amoCRM: речевая аналитика звонков в карточке сделки — РОП видит качество, а не только количество.",
      "desc": "Речевая аналитика расшифровывает звонки и оценивает их по скриптам: наличие приветствия, работа с возражениями, упоминание акций. Результаты попадают в сделку, РОП видит качество работы каждого менеджера.",
      "price": "от 35 000 ₽",
      "duration": "7–14 рабочих дней",
      "category": "telephony",
      "industries": [
        "B2B-услуги",
        "E-commerce",
        "Медицина"
      ],
      "related": [
        "telefoniya",
        "sipuni",
        "claude"
      ],
      "faq": [
        {
          "q": "Как оценивается качество?",
          "a": "По чек-листу, который вы задаете: приветствие, выявление потребности, работа с возражениями, закрытие на следующий шаг."
        },
        {
          "q": "Нужны ли записи всех звонков?",
          "a": "Анализируется выборка или все звонки — зависит от тарифа и задачи."
        }
      ]
    },
    {
      "slug": "skorozvon",
      "icon": "ri-phone-off-line",
      "title": "Скорозвон",
      "shortDesc": "Скорозвон и amoCRM: обзвон из CRM — менеджер звонит по очереди, результат и запись попадают в сделку.",
      "desc": "Скорозвон automatizирует исходящие обзвоны: менеджер работает по очереди из CRM, результат разговора и запись автоматически попадают в сделку. Удобно для холодных баз и реактивации.",
      "price": "от 25 000 ₽",
      "duration": "3–7 рабочих дней",
      "category": "telephony",
      "industries": [
        "B2B-услуги",
        "Услуги",
        "Образование"
      ],
      "related": [
        "telefoniya",
        "onlinepbx",
        "speech-analytics"
      ],
      "faq": [
        {
          "q": "Подходит ли для холодных звонков?",
          "a": "Да, это основной сценарий: автодозвон, скрипты и фиксация результата в CRM."
        },
        {
          "q": "Можно ли ставить задачи по результату?",
          "a": "Да, по итогу звонка автоматически создается задача на следующий шаг."
        }
      ]
    },
    {
      "slug": "1c",
      "icon": "ri-database-2-line",
      "title": "Интеграция с 1С",
      "shortDesc": "Двусторонний обмен данными между CRM и учётной системой: заказы, счета, контрагенты — без ручного дублирования.",
      "desc": "Настраиваем интеграцию amoCRM с 1С: УТ, БП, ERP и другие конфигурации. Синхронизация контрагентов, заказов, счетов и статусов оплаты. Подбираем схему: готовый коннектор, промежуточный сервис или кастомная разработка.",
      "price": "от 65 000 ₽",
      "duration": "10–21 рабочий день",
      "category": "accounting",
      "industries": [
        "E-commerce",
        "B2B-услуги",
        "Производство"
      ],
      "related": [
        "mojsklad",
        "albato",
        "getcourse",
        "planfact",
        "sajt"
      ],
      "faq": [
        {
          "q": "Какие конфигурации 1С поддерживаются?",
          "a": "1С:УТ, 1С:БП, 1С:ERP и другие — через API, CommerceML или промежуточный сервис. Точная схема определяется на аудите."
        },
        {
          "q": "Интеграция в реальном времени или по расписанию?",
          "a": "Зависит от задачи. Критичные события — webhook или частый polling, массовая синхронизация справочников — по расписанию."
        },
        {
          "q": "Кто отвечает за поддержку интеграции?",
          "a": "Мы сопровождаем интеграцию после запуска: мониторинг ошибок, доработки при обновлениях 1С или amoCRM."
        }
      ]
    },
    {
      "slug": "mojsklad",
      "icon": "ri-archive-2-line",
      "title": "МойСклад",
      "shortDesc": "Синхронизация заказов, товаров и остатков между CRM и складским учётом без ручного переноса.",
      "desc": "МойСклад и amoCRM обмениваются заказами, товарами и остатками: менеджер видит актуальное наличие в сделке, а склад получает заказ сразу после подтверждения. Без двойного ввода и расхождений.",
      "price": "от 40 000 ₽",
      "duration": "7–14 рабочих дней",
      "category": "accounting",
      "industries": [
        "E-commerce",
        "Производство",
        "Логистика"
      ],
      "related": [
        "1c",
        "cdek",
        "ozon"
      ],
      "faq": [
        {
          "q": "Передаются ли остатки в реальном времени?",
          "a": "Да, остатки обновляются по API — менеджер видит актуальное наличие."
        },
        {
          "q": "Можно ли создать заказ из сделки?",
          "a": "Да, заказ в МойСклад создается из карточки сделки одним действием."
        }
      ]
    },
    {
      "slug": "roistat",
      "icon": "ri-line-chart-line",
      "title": "Roistat",
      "shortDesc": "Связка рекламных затрат с продажами в CRM: от клика до оплаты с атрибуцией по каналам.",
      "desc": "Roistat связывает рекламные расходы с продажами в amoCRM: видно, какой канал принес сделку и сколько она стоила. Сквозная аналитика от клика до оплаты, включая офлайн-продажи.",
      "price": "от 35 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "accounting",
      "industries": [
        "E-commerce",
        "Услуги",
        "Недвижимость"
      ],
      "related": [
        "yandex-metrika",
        "calltouch",
        "comagic"
      ],
      "faq": [
        {
          "q": "Нужен ли договор с Roistat?",
          "a": "Да, потребуется действующий аккаунт Roistat — интеграцию настраиваем на его базе."
        },
        {
          "q": "Передаются ли статусы сделок?",
          "a": "Да, статусы и суммы передаются в Roistat для расчета ROI по каналам."
        }
      ]
    },
    {
      "slug": "yandex-metrika",
      "icon": "ri-bar-chart-line",
      "title": "Яндекс.Метрика",
      "shortDesc": "Передаём статусы сделок в Метрику для оптимизации рекламы по реальным продажам, а не только по заявкам.",
      "desc": "Интеграция amoCRM с Яндекс.Метрикой: статусы сделок и суммы передаются как цели, и рекламные кампании оптимизируются по реальным продажам. Яндекс видит не заявки, а деньги.",
      "price": "от 28 000 ₽",
      "duration": "3–7 рабочих дней",
      "category": "accounting",
      "industries": [
        "E-commerce",
        "Услуги",
        "Образование"
      ],
      "related": [
        "roistat",
        "calltouch",
        "google-sheets"
      ],
      "faq": [
        {
          "q": "Какие цели передаются?",
          "a": "Квалификация лида, успешная сделка, оплата — набор настраивается под вашу воронку."
        },
        {
          "q": "Можно ли передавать сумму сделки?",
          "a": "Да, через цель с revenue — это позволяет оптимизировать кампании по выручке."
        }
      ]
    },
    {
      "slug": "yclients",
      "icon": "ri-calendar-check-line",
      "title": "YClients",
      "shortDesc": "Запись из YClients и коммерческая воронка в amoCRM — без двойного учёта и потерянных повторных визитов.",
      "desc": "YClients (запись клиентов) синхронизируется с amoCRM: визиты и записи попадают в воронку, а CRM видит историю посещений. Повторные визиты не теряются, а маркетинг работает по реальным данным.",
      "price": "от 35 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "accounting",
      "industries": [
        "Красота",
        "Медицина",
        "Услуги"
      ],
      "related": [
        "1c",
        "ident",
        "smsru"
      ],
      "faq": [
        {
          "q": "Что синхронизируется?",
          "a": "Клиенты, записи, визиты и статусы оплат. Направление обмена настраивается под процесс."
        },
        {
          "q": "Избегаем ли дублей клиентов?",
          "a": "Да, сопоставление идет по телефону и email с правилами объединения."
        }
      ]
    },
    {
      "slug": "albato",
      "icon": "ri-plug-2-line",
      "title": "Albato",
      "shortDesc": "Albato связывает amoCRM с десятками сервисов без разработки: формы, таблицы, рассылки и внутренние системы.",
      "desc": "Albato — low-code интегратор: связывает amoCRM с десятками сервисов без разработки. Подходит, когда нужна быстрая связка с нестандартной системой или когда готового коннектора нет.",
      "price": "от 20 000 ₽",
      "duration": "3–7 рабочих дней",
      "category": "accounting",
      "industries": [
        "E-commerce",
        "B2B-услуги",
        "Услуги"
      ],
      "related": [
        "1c",
        "google-sheets",
        "sendpulse"
      ],
      "faq": [
        {
          "q": "Когда выбирать Albato, а не кастом?",
          "a": "Когда нужен быстрый запуск и стандартные сценарии. Для сложной логики и высоких нагрузок лучше кастомная интеграция."
        },
        {
          "q": "Есть ли лимиты по операциям?",
          "a": "Да, зависят от тарифа Albato — учитываем это при проектировании обмена."
        }
      ]
    },
    {
      "slug": "claude",
      "icon": "ri-brain-line",
      "title": "Claude AI",
      "shortDesc": "Claude помогает разбирать переписку и звонки в amoCRM: саммари для РОПа, подсказки менеджеру, меньше ручного разбора чатов.",
      "desc": "Claude AI подключается к amoCRM для анализа переписки и расшифровок звонков: делает саммари сделки, выделяет риски и подсказывает следующий шаг. РОП тратит меньше времени на ручной разбор диалогов.",
      "price": "от 35 000 ₽",
      "duration": "7–14 рабочих дней",
      "category": "accounting",
      "industries": [
        "B2B-услуги",
        "E-commerce",
        "IT"
      ],
      "related": [
        "chatgpt",
        "speech-analytics",
        "suvvy"
      ],
      "faq": [
        {
          "q": "Где хранятся данные при обработке?",
          "a": "Передаются только нужные фрагменты диалога. Схему работы с данными согласуем отдельно, включая требования 152-ФЗ."
        },
        {
          "q": "Что попадает в сделку?",
          "a": "Краткое саммари, ключевые договоренности и рекомендация следующего шага."
        }
      ]
    },
    {
      "slug": "calltouch",
      "icon": "ri-phone-check-line",
      "title": "Calltouch",
      "shortDesc": "Calltouch (колтач) передаёт звонки и метки рекламы в amoCRM — РОП видит канал не только по заявкам с сайта.",
      "desc": "Calltouch — коллтрекинг и сквозная аналитика: определяет источник звонка, подменяет номер и передает данные в amoCRM. РОП видит полную картину по каналам, включая звонки.",
      "price": "от 25 000 ₽",
      "duration": "3–7 рабочих дней",
      "category": "accounting",
      "industries": [
        "E-commerce",
        "Услуги",
        "Медицина"
      ],
      "related": [
        "comagic",
        "roistat",
        "sajt"
      ],
      "faq": [
        {
          "q": "Нужны ли подменные номера?",
          "a": "Да, для коллтрекинга используется пул номеров — настраиваем вместе с Calltouch."
        },
        {
          "q": "Что попадает в сделку?",
          "a": "Источник, кампания, ключевое слово и ссылка на запись разговора."
        }
      ]
    },
    {
      "slug": "yandex-disk",
      "icon": "ri-hard-drive-2-line",
      "title": "Яндекс Диск",
      "shortDesc": "Файлы сделки на Яндекс Диске: договоры, КП и акты в карточке amoCRM без хаоса в почте и чатах.",
      "desc": "Интеграция с Яндекс Диском: файлы из сделки автоматически сохраняются в структурированные папки, а из Диска — прикрепляются к карточке. Документы не теряются и доступны по единой ссылке.",
      "price": "от 20 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "accounting",
      "industries": [
        "B2B-услуги",
        "Производство",
        "Услуги"
      ],
      "related": [
        "google-drive",
        "yandex-calendar",
        "1c"
      ],
      "faq": [
        {
          "q": "Как организованы папки?",
          "a": "Структура настраивается: по клиентам, сделкам или годам — как удобно вашей команде."
        },
        {
          "q": "Сохраняются ли права доступа?",
          "a": "Да, доступ наследуется из Яндекс Диска, а ссылки в CRM ведут на актуальные файлы."
        }
      ]
    },
    {
      "slug": "unisender",
      "icon": "ri-send-plane-line",
      "title": "Unisender",
      "shortDesc": "Сегменты и статусы из amoCRM в Unisender: рассылки по этапу воронки, без ручного экспорта базы.",
      "desc": "Синхронизация amoCRM и Unisender: сегменты формируются по этапам воронки и тегам, статусы обновляются автоматически. Маркетинг отправляет письма по актуальной базе без ручных выгрузок.",
      "price": "от 25 000 ₽",
      "duration": "3–7 рабочих дней",
      "category": "accounting",
      "industries": [
        "E-commerce",
        "Образование",
        "B2B-услуги"
      ],
      "related": [
        "sendpulse",
        "getcourse",
        "smsru"
      ],
      "faq": [
        {
          "q": "Как формируются сегменты?",
          "a": "По правилам CRM: этап сделки, теги, поля. Синхронизация обновляет сегменты автоматически."
        },
        {
          "q": "Отслеживается ли статистика рассылки?",
          "a": "Да, открытия и переходы можно возвращать в CRM как события."
        }
      ]
    },
    {
      "slug": "getcourse",
      "icon": "ri-graduation-cap-line",
      "title": "GetCourse",
      "shortDesc": "Заявки и оплаты с GetCourse в amoCRM: менеджер ведёт прогрев и дожим, маркетинг видит воронку курса в CRM.",
      "desc": "GetCourse и amoCRM: заявки, регистрации и оплаты попадают в CRM, а воронка курса видна целиком. Менеджер дожимает тех, кто не оплатил, по данным из LMS.",
      "price": "от 30 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "accounting",
      "industries": [
        "Образование",
        "Инфобизнес"
      ],
      "related": [
        "calibri",
        "alfacrm",
        "unisender"
      ],
      "faq": [
        {
          "q": "Передаются ли оплаты?",
          "a": "Да, факт оплаты и сумма попадают в сделку, что позволяет считать конверсию в оплату."
        },
        {
          "q": "Работает ли с вебинарами?",
          "a": "Да, регистрации и посещения вебинаров можно передавать как события."
        }
      ]
    },
    {
      "slug": "google-sheets",
      "icon": "ri-table-line",
      "title": "Google Таблицы",
      "shortDesc": "Сделки и отчёты синхронизируются с Google Таблицами — РОП и маркетинг видят актуальные цифры без ручного экспорта.",
      "desc": "Автоматическая выгрузка сделок и отчетов в Google Таблицы: данные обновляются по расписанию, руководитель видит актуальные цифры в привычном формате. Без ручного экспорта и устаревших отчетов.",
      "price": "от 18 000 ₽",
      "duration": "2–5 рабочих дней",
      "category": "accounting",
      "industries": [
        "B2B-услуги",
        "E-commerce",
        "Услуги"
      ],
      "related": [
        "google-calendar",
        "albato",
        "planfact"
      ],
      "faq": [
        {
          "q": "Как часто обновляются данные?",
          "a": "По расписанию — от 15 минут до раза в сутки, в зависимости от задачи."
        },
        {
          "q": "Можно ли писать обратно в CRM?",
          "a": "Да, при необходимости настраиваем и обратную синхронизацию отдельных полей."
        }
      ]
    },
    {
      "slug": "google-calendar",
      "icon": "ri-calendar-2-line",
      "title": "Google Календарь",
      "shortDesc": "Встречи и задачи из amoCRM в Google Календаре: менеджер не пропускает созвоны, РОП видит загрузку команды.",
      "desc": "Двусторонняя синхронизация задач и встреч amoCRM с Google Календарем. Менеджер планирует день в привычном календаре, а изменения отражаются в CRM — встречи не теряются.",
      "price": "от 15 000 ₽",
      "duration": "2–4 рабочих дня",
      "category": "accounting",
      "industries": [
        "B2B-услуги",
        "IT",
        "Услуги"
      ],
      "related": [
        "yandex-calendar",
        "google-sheets",
        "1c"
      ],
      "faq": [
        {
          "q": "Синхронизация двусторонняя?",
          "a": "Да, изменения в календаре отражаются в CRM и наоборот."
        },
        {
          "q": "Какие события переносятся?",
          "a": "Задачи с датой и встречи из сделок."
        }
      ]
    },
    {
      "slug": "chatgpt",
      "icon": "ri-openai-line",
      "title": "ChatGPT",
      "shortDesc": "ChatGPT помогает по сделкам в amoCRM: саммари переписки, черновики ответов, разбор для РОПа — без ручного копирования в чат.",
      "desc": "ChatGPT подключается к amoCRM: готовит саммари по переписке сделки, предлагает черновики ответов и разбор возражений. Менеджер отвечает быстрее, РОП видит сжатый контекст без чтения длинных диалогов.",
      "price": "от 35 000 ₽",
      "duration": "7–14 рабочих дней",
      "category": "accounting",
      "industries": [
        "B2B-услуги",
        "E-commerce",
        "IT"
      ],
      "related": [
        "claude",
        "suvvy",
        "speech-analytics"
      ],
      "faq": [
        {
          "q": "Куда отправляются данные?",
          "a": "Только фрагменты, необходимые для ответа. Вариант с локальной моделью обсуждается отдельно."
        },
        {
          "q": "Можно ли использовать для обучения менеджеров?",
          "a": "Да, разбор реальных диалогов с рекомендациями — один из популярных сценариев."
        }
      ]
    },
    {
      "slug": "ident",
      "icon": "ri-hospital-line",
      "title": "IDENT",
      "shortDesc": "IDENT + amoCRM для стоматологии: запись, пациент и оплата в одной воронке — администратор и менеджер не дублируют данные.",
      "desc": "IDENT (медицинская информационная система для стоматологии) синхронизируется с amoCRM: запись пациента, статус приема и оплата попадают в воронку. Администратор не дублирует данные, а маркетинг видит возвращаемость пациентов.",
      "price": "от 45 000 ₽",
      "duration": "7–14 рабочих дней",
      "category": "accounting",
      "industries": [
        "Стоматология",
        "Медицина"
      ],
      "related": [
        "mis",
        "medods",
        "sqns-denta",
        "yclients"
      ],
      "faq": [
        {
          "q": "Что синхронизируется?",
          "a": "Пациенты, записи, статусы приема и оплаты — состав обмена согласуем под процессы клиники."
        },
        {
          "q": "Можно ли считать LTV пациента?",
          "a": "Да, при передаче визитов и оплат в CRM выстраивается полная история пациента."
        }
      ]
    },
    {
      "slug": "yandex-calendar",
      "icon": "ri-calendar-check-line",
      "title": "Яндекс Календарь",
      "shortDesc": "Встречи и задачи из amoCRM в Яндекс Календаре — удобно командам, которые уже живут в экосистеме Яндекса.",
      "desc": "Синхронизация задач и встреч amoCRM с Яндекс Календарем: менеджер видит план в привычном интерфейсе, а изменения сохраняются в CRM. Удобно для команд на Яндекс 360.",
      "price": "от 15 000 ₽",
      "duration": "2–4 рабочих дня",
      "category": "accounting",
      "industries": [
        "B2B-услуги",
        "Услуги",
        "Производство"
      ],
      "related": [
        "google-calendar",
        "yandex-mail",
        "yandex-disk"
      ],
      "faq": [
        {
          "q": "Требуется ли Яндекс 360?",
          "a": "Желательно для корпоративного контура — так проще управлять доступами."
        },
        {
          "q": "Что попадает в календарь?",
          "a": "Задачи с датой, встречи и напоминания из сделок."
        }
      ]
    },
    {
      "slug": "sendpulse",
      "icon": "ri-mail-star-line",
      "title": "SendPulse",
      "shortDesc": "Сегменты и рассылки SendPulse из amoCRM: email и мессенджеры по этапу воронки без ручного экспорта.",
      "desc": "SendPulse и amoCRM: сегменты обновляются по данным CRM, рассылки уходят по этапу воронки, а события возвращаются в сделку. Email и мессенджеры в одном контуре с продажами.",
      "price": "от 25 000 ₽",
      "duration": "3–7 рабочих дней",
      "category": "accounting",
      "industries": [
        "E-commerce",
        "Образование",
        "Услуги"
      ],
      "related": [
        "unisender",
        "getcourse",
        "telegram"
      ],
      "faq": [
        {
          "q": "Какие каналы доступны?",
          "a": "Email, SMS, Telegram и Viber — в зависимости от тарифа SendPulse."
        },
        {
          "q": "Возвращается ли статистика?",
          "a": "Да, открытия и клики можно фиксировать в CRM как события."
        }
      ]
    },
    {
      "slug": "mis",
      "icon": "ri-heart-pulse-line",
      "title": "МИС",
      "shortDesc": "МИС + amoCRM для клиник: запись, пациент и оплата в CRM — администратор не дублирует данные между системами.",
      "desc": "Интеграция медицинской информационной системы с amoCRM: запись пациента, визит и оплата синхронизируются с воронкой. Клиника видит полную историю пациента, а маркетинг — возвращаемость.",
      "price": "от 45 000 ₽",
      "duration": "7–14 рабочих дней",
      "category": "accounting",
      "industries": [
        "Медицина",
        "Стоматология"
      ],
      "related": [
        "ident",
        "medods",
        "yclients"
      ],
      "faq": [
        {
          "q": "С какими МИС работаете?",
          "a": "С популярными клиническими системами — схема зависит от наличия API. Точный вариант определяем на аудите."
        },
        {
          "q": "Соблюдается ли 152-ФЗ?",
          "a": "Да, передаются только необходимые данные, контур согласуем с вашим ответственным за ИБ."
        }
      ]
    },
    {
      "slug": "medods",
      "icon": "ri-stethoscope-line",
      "title": "Medods",
      "shortDesc": "Medods + amoCRM для клиник: запись, пациент и оплата в CRM — администратор не переносит данные вручную.",
      "desc": "Medods синхронизируется с amoCRM: записи, пациенты и оплаты попадают в воронку автоматически. Администратор не дублирует данные, а руководство видит загрузку и возвращаемость.",
      "price": "от 45 000 ₽",
      "duration": "7–14 рабочих дней",
      "category": "accounting",
      "industries": [
        "Медицина"
      ],
      "related": [
        "ident",
        "mis",
        "smsru"
      ],
      "faq": [
        {
          "q": "Что передается в CRM?",
          "a": "Запись, статус визита и оплата. Персональные медицинские данные остаются в Medods."
        },
        {
          "q": "Можно ли слать напоминания?",
          "a": "Да, через SMS или мессенджеры из роботов CRM."
        }
      ]
    },
    {
      "slug": "sqns-denta",
      "icon": "ri-tooth-line",
      "title": "SQNS Denta",
      "shortDesc": "SQNS Denta + amoCRM для стоматологии: запись и пациент в CRM — администратор видит воронку, а не только расписание.",
      "desc": "SQNS Denta синхронизируется с amoCRM: записи и пациенты попадают в воронку, оплаты фиксируются в сделке. Администратор работает с расписанием, а руководство видит сквозную картину.",
      "price": "от 45 000 ₽",
      "duration": "7–14 рабочих дней",
      "category": "accounting",
      "industries": [
        "Стоматология"
      ],
      "related": [
        "ident",
        "mis",
        "medods"
      ],
      "faq": [
        {
          "q": "Передается ли план лечения?",
          "a": "Базовые данные и этапы — состав зависит от доступного API SQNS Denta."
        },
        {
          "q": "Как считается возвращаемость?",
          "a": "По визитам и оплатам в сделке — видно, кто вернулся, а кто отвалился."
        }
      ]
    },
    {
      "slug": "bizon365",
      "icon": "ri-vidicon-line",
      "title": "Bizon365",
      "shortDesc": "Регистрации и активность с вебинаров Bizon365 в amoCRM — менеджер дожимает горячих после эфира, а не теряет их в кабинете.",
      "desc": "Bizon365 передает в amoCRM регистрации, посещение и активность на вебинарах. Менеджер видит, кто досмотрел эфир и кликал по ссылкам, и дожимает именно горячих.",
      "price": "от 30 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "accounting",
      "industries": [
        "Образование",
        "Инфобизнес",
        "B2B-услуги"
      ],
      "related": [
        "getcourse",
        "sendpulse",
        "calibri"
      ],
      "faq": [
        {
          "q": "Какие метрики передаются?",
          "a": "Регистрация, факт посещения, длительность просмотра и клики по ссылкам."
        },
        {
          "q": "Можно ли сегментировать по активности?",
          "a": "Да, по этим данным настраиваются сегменты и автосценарии дожима."
        }
      ]
    },
    {
      "slug": "calibri",
      "icon": "ri-book-open-line",
      "title": "Calibri",
      "shortDesc": "Calibri и amoCRM: ученики, оплаты и статусы курса в CRM — менеджер дожимает без выгрузок из LMS.",
      "desc": "Calibri (LMS) обменивается с amoCRM данными об учениках, оплатах и прогрессе курса. Менеджер видит, кто застрял на этапе, и дожимает без ручных выгрузок.",
      "price": "от 30 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "accounting",
      "industries": [
        "Образование",
        "Инфобизнес"
      ],
      "related": [
        "getcourse",
        "alfacrm",
        "listok"
      ],
      "faq": [
        {
          "q": "Что синхронизируется?",
          "a": "Ученики, оплаты, доступ к курсам и прогресс обучения."
        },
        {
          "q": "Можно ли считать LTV ученика?",
          "a": "Да, при передаче нескольких покупок в одну карточку."
        }
      ]
    },
    {
      "slug": "planfact",
      "icon": "ri-file-chart-line",
      "title": "ПланФакт",
      "shortDesc": "ПланФакт и amoCRM: оплаты и выручка по сделкам — финансы и продажи сходятся без ручной сверки.",
      "desc": "ПланФакт (финансовый учет) синхронизируется с amoCRM: оплаты и выручка по сделкам попадают в финансовый контур. Финансы и продажи сходятся без ручной сверки и расхождений.",
      "price": "от 35 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "accounting",
      "industries": [
        "B2B-услуги",
        "E-commerce",
        "Производство"
      ],
      "related": [
        "1c",
        "mojsklad",
        "google-sheets"
      ],
      "faq": [
        {
          "q": "Какие данные передаются?",
          "a": "Суммы сделок, факт оплаты, даты и контрагенты."
        },
        {
          "q": "Заменяет ли это 1С?",
          "a": "Нет, ПланФакт — управленческий контур. При наличии 1С выстраиваем связку из трех систем."
        }
      ]
    },
    {
      "slug": "posiflora",
      "icon": "ri-shopping-bag-line",
      "title": "Posiflora",
      "shortDesc": "Posiflora и amoCRM для цветочного: заказы, доставка и клиент в CRM — менеджер дожимает без выгрузок из кассы.",
      "desc": "Posiflora (учет для цветочного бизнеса) синхронизируется с amoCRM: заказы, доставка и данные клиента попадают в CRM. Менеджер видит повторные заказы и дожимает без выгрузок из кассы.",
      "price": "от 30 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "accounting",
      "industries": [
        "E-commerce",
        "Ритейл"
      ],
      "related": [
        "mojsklad",
        "1c",
        "smsru"
      ],
      "faq": [
        {
          "q": "Что попадает в CRM?",
          "a": "Заказы, состав букета, дата доставки и контакт получателя."
        },
        {
          "q": "Можно ли напоминать о праздниках?",
          "a": "Да, по истории заказов настраиваются сценарии к датам."
        }
      ]
    },
    {
      "slug": "ati",
      "icon": "ri-truck-line",
      "title": "ATI.su",
      "shortDesc": "ATI.su и amoCRM для логистики: заявки и сделки по перевозкам в CRM — менеджер не теряет груз в личном кабинете биржи.",
      "desc": "ATI.su (биржа грузоперевозок) передает заявки и отклики в amoCRM. Логист работает с заявками в CRM, а не в кабинете биржи, и не теряет груз между вкладками.",
      "price": "от 35 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "accounting",
      "industries": [
        "Логистика"
      ],
      "related": [
        "1c",
        "planado",
        "cdek"
      ],
      "faq": [
        {
          "q": "Какие данные передаются?",
          "a": "Заявка, маршрут, тип груза, ставка и контакты."
        },
        {
          "q": "Можно ли вести рейс до выгрузки?",
          "a": "Да, этапы перевозки настраиваются как статусы сделки."
        }
      ]
    },
    {
      "slug": "alfacrm",
      "icon": "ri-school-line",
      "title": "AlfaCRM",
      "shortDesc": "AlfaCRM и amoCRM для учебного центра: ученик, оплата и статус в CRM — менеджер дожимает без выгрузок из LMS.",
      "desc": "AlfaCRM (CRM для учебных центров) синхронизируется с amoCRM: ученики, абонементы и оплаты попадают в воронку. Менеджер видит статус обучения и дожимает на продление.",
      "price": "от 30 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "accounting",
      "industries": [
        "Образование"
      ],
      "related": [
        "listok",
        "calibri",
        "getcourse"
      ],
      "faq": [
        {
          "q": "Зачем две CRM?",
          "a": "AlfaCRM закрывает специфику учебного центра (расписание, абонементы), amoCRM — продажи. Интеграция убирает двойной ввод."
        },
        {
          "q": "Что синхронизируется?",
          "a": "Ученики, оплаты, посещения и статусы абонементов."
        }
      ]
    },
    {
      "slug": "listok",
      "icon": "ri-file-list-3-line",
      "title": "ListOK CRM",
      "shortDesc": "ListOK и amoCRM для учебного центра: ученик, абонемент и оплата в CRM — менеджер дожимает без выгрузок из LMS.",
      "desc": "ListOK CRM обменивается с amoCRM данными об учениках, абонементах и оплатах. Продажи и обучение сходятся в одном контуре, менеджер видит, кому пора продлить абонемент.",
      "price": "от 30 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "accounting",
      "industries": [
        "Образование"
      ],
      "related": [
        "alfacrm",
        "calibri",
        "mojklass"
      ],
      "faq": [
        {
          "q": "Что передается в amoCRM?",
          "a": "Ученик, абонемент, оплата и остаток занятий."
        },
        {
          "q": "Можно ли слать напоминания об оплате?",
          "a": "Да, по остатку занятий настраиваются автосценарии."
        }
      ]
    },
    {
      "slug": "google-drive",
      "icon": "ri-hard-drive-line",
      "title": "Google Диск",
      "shortDesc": "Файлы сделки на Google Диске: договоры, КП и акты в карточке amoCRM без хаоса в почте и чатах.",
      "desc": "Интеграция с Google Диском: документы из сделки сохраняются в структурированные папки, а файлы из Диска прикрепляются к карточке. Единая точка хранения вместо вложений в почте.",
      "price": "от 20 000 ₽",
      "duration": "3–5 рабочих дней",
      "category": "accounting",
      "industries": [
        "B2B-услуги",
        "IT",
        "Услуги"
      ],
      "related": [
        "yandex-disk",
        "google-sheets",
        "1c"
      ],
      "faq": [
        {
          "q": "Можно ли настроить права доступа?",
          "a": "Да, права наследуются из Google Диска, а доступ к папкам управляется отдельно."
        },
        {
          "q": "Что с шарингом клиенту?",
          "a": "Можно формировать ссылку на просмотр и отправлять ее из сделки."
        }
      ]
    },
    {
      "slug": "stripe",
      "icon": "ri-bank-card-line",
      "title": "Stripe",
      "shortDesc": "Stripe и amoCRM: оплаты и подписки в карточке сделки — менеджер и РОП видят факт денег без ручной сверки.",
      "desc": "Интеграция Stripe с amoCRM: платежи, подписки и возвраты фиксируются в сделке. Менеджер видит факт оплаты, а РОП — реальную кассу по подпискам без ручной сверки.",
      "price": "от 35 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "accounting",
      "industries": [
        "IT",
        "E-commerce",
        "SaaS"
      ],
      "related": [
        "1c",
        "planfact",
        "sajt"
      ],
      "faq": [
        {
          "q": "Поддерживаются ли подписки?",
          "a": "Да, события по подпискам (продление, отмена, возврат) передаются в сделку."
        },
        {
          "q": "Как попадают платежи?",
          "a": "Через webhook Stripe — мгновенно, с суммой и статусом."
        }
      ]
    },
    {
      "slug": "planado",
      "icon": "ri-map-pin-time-line",
      "title": "Planado",
      "shortDesc": "Planado и amoCRM: выездные задачи из сделки — мастер видит наряд, РОП контролирует SLA без Excel.",
      "desc": "Planado (планирование выездов) интегрируется с amoCRM: из сделки создается наряд, мастер получает задание, а статус выполнения возвращается в CRM. Диспетчер не дублирует данные.",
      "price": "от 35 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "accounting",
      "industries": [
        "Услуги",
        "Логистика",
        "IT"
      ],
      "related": [
        "ati",
        "yclients",
        "google-calendar"
      ],
      "faq": [
        {
          "q": "Как передается наряд?",
          "a": "Из карточки сделки формируется задание с адресом, описанием и сроком."
        },
        {
          "q": "Возвращается ли статус?",
          "a": "Да, выполнение и фотоотчет отражаются в сделке."
        }
      ]
    },
    {
      "slug": "iiko",
      "icon": "ri-restaurant-line",
      "title": "iiko",
      "shortDesc": "iiko и amoCRM для HoReCa: заказы и гости в CRM — менеджер B2B и маркетинг видят клиента, а не только чек в кассе.",
      "desc": "iiko (учет для ресторанов) синхронизируется с amoCRM: заказы, гости и банкетные заявки попадают в CRM. B2B-направление и маркетинг видят клиента целиком, а не только чек в кассе.",
      "price": "от 40 000 ₽",
      "duration": "7–14 рабочих дней",
      "category": "accounting",
      "industries": [
        "HoReCa"
      ],
      "related": [
        "1c",
        "posiflora",
        "smsru"
      ],
      "faq": [
        {
          "q": "Какие данные передаются?",
          "a": "Заказы, гости, банкетные заявки и суммы — состав зависит от доступного API iiko."
        },
        {
          "q": "Работает ли для доставки?",
          "a": "Да, заказы доставки можно вести как сделки с этапами."
        }
      ]
    },
    {
      "slug": "smsru",
      "icon": "ri-message-2-line",
      "title": "SMS.ru",
      "shortDesc": "SMS.ru и amoCRM: SMS из сценариев CRM — напоминания, коды и статусы клиенту без ручной рассылки.",
      "desc": "SMS.ru подключается к amoCRM: сообщения отправляются из роботов и при смене этапа — напоминания, коды, статусы. Клиент получает информацию вовремя, менеджер видит факт отправки в сделке.",
      "price": "от 15 000 ₽",
      "duration": "2–4 рабочих дня",
      "category": "accounting",
      "industries": [
        "E-commerce",
        "Медицина",
        "Услуги"
      ],
      "related": [
        "smsc",
        "targetsms",
        "unisender"
      ],
      "faq": [
        {
          "q": "Можно ли отправлять из роботов?",
          "a": "Да, при смене этапа или по условию — с подстановкой полей сделки."
        },
        {
          "q": "Как отследить доставку?",
          "a": "Статус доставки возвращается в CRM и фиксируется в сделке."
        }
      ]
    },
    {
      "slug": "smsc",
      "icon": "ri-chat-3-line",
      "title": "SMS-центр",
      "shortDesc": "SMSC.ru и amoCRM: SMS из роботов и этапов — клиент получает статус, менеджер видит факт отправки в сделке.",
      "desc": "SMS-центр (SMSC.ru) интегрируется с amoCRM: рассылки и транзакционные сообщения уходят из сценариев CRM. Отправка и статус доставки фиксируются в сделке.",
      "price": "от 15 000 ₽",
      "duration": "2–4 рабочих дня",
      "category": "accounting",
      "industries": [
        "E-commerce",
        "Услуги",
        "Медицина"
      ],
      "related": [
        "smsru",
        "targetsms",
        "sendpulse"
      ],
      "faq": [
        {
          "q": "Поддерживаются ли шаблоны?",
          "a": "Да, с подстановкой полей сделки и контакта."
        },
        {
          "q": "Есть ли отчет по рассылкам?",
          "a": "Да, статистика доступна в кабинете SMSC и частично в CRM."
        }
      ]
    },
    {
      "slug": "targetsms",
      "icon": "ri-send-plane-2-line",
      "title": "TargetSMS",
      "shortDesc": "TargetSMS и amoCRM: SMS из роботов и этапов — клиент получает напоминание, менеджер видит факт отправки в сделке.",
      "desc": "TargetSMS подключается к amoCRM: напоминания и уведомления отправляются автоматически по этапам воронки, статус доставки возвращается в сделку.",
      "price": "от 15 000 ₽",
      "duration": "2–4 рабочих дня",
      "category": "accounting",
      "industries": [
        "E-commerce",
        "Услуги",
        "Образование"
      ],
      "related": [
        "smsru",
        "smsc",
        "unisender"
      ],
      "faq": [
        {
          "q": "Чем отличается от SMS.ru?",
          "a": "Функционально близки: тарифы и интерфейс. Интегрируем тот сервис, который у вас уже оплачен."
        },
        {
          "q": "Можно ли отправлять массово?",
          "a": "Да, из сегментов CRM с учетом согласий на рассылку."
        }
      ]
    },
    {
      "slug": "mojklass",
      "icon": "ri-parent-line",
      "title": "Мой класс",
      "shortDesc": "Мой класс и amoCRM: ученики, абонементы и оплаты в CRM — менеджер дожимает без выгрузок из LMS.",
      "desc": "«Мой класс» (LMS для учебных центров) синхронизируется с amoCRM: ученики, абонементы и оплаты попадают в воронку. Менеджер видит, кому пора продлить обучение.",
      "price": "от 30 000 ₽",
      "duration": "5–10 рабочих дней",
      "category": "accounting",
      "industries": [
        "Образование"
      ],
      "related": [
        "alfacrm",
        "listok",
        "calibri"
      ],
      "faq": [
        {
          "q": "Что попадает в CRM?",
          "a": "Ученик, абонемент, оплата и остаток занятий."
        },
        {
          "q": "Можно ли автоматизировать продления?",
          "a": "Да, по остатку занятий настраивается задача менеджеру."
        }
      ]
    }
  ],
  "faq": {
    "badge": "FAQ",
    "title": "Частые вопросы по интеграциям",
    "subtitle": "Не нашли ответ — напишите, ответим в течение 15 минут",
    "items": [
      {
        "q": "С чего начать, если каналов много?",
        "a": "Обычно в первую очередь подключаем сайт и телефонию (или основной мессенджер), затем остальные каналы. Так команда сразу видит весь входящий поток в одной воронке, а вы — где теряются заявки."
      },
      {
        "q": "Интеграция входит во внедрение amoCRM?",
        "a": "Да, в полном внедрении под ключ. Можно заказать и только интеграции к уже работающей CRM — мы подключаемся к вашему аккаунту и не ломаем текущие процессы."
      },
      {
        "q": "Сколько стоит подключение одного канала?",
        "a": "Ориентир указан на карточках интеграций. Итоговая смета зависит от тарифа сервиса, числа аккаунтов и правил распределения лидов. После короткого созвона называем фиксированную цену."
      },
      {
        "q": "Что если моей системы нет в списке?",
        "a": "Напишите нам. Через нашу платформу подключаем практически любую систему с API — от внутренней самописной базы до отраслевого софта."
      },
      {
        "q": "Кто поддерживает интеграцию после запуска?",
        "a": "Мы. Мониторим ошибки, дорабатываем при обновлениях внешних систем и отвечаем на вопросы команды — по абонентскому договору или разовыми задачами."
      }
    ]
  },
  "lead": {
    "title": "Не нашли свою систему? **Подключим** почти любую",
    "text": "Опишите задачу — предложим схему интеграции, назовём сроки и фиксированную цену. Бесплатный аудит текущих связок и подсказки, что стоит автоматизировать в первую очередь.",
    "bullets": [
      {
        "icon": "ri-time-line",
        "text": "Ответим в течение 15 минут"
      },
      {
        "icon": "ri-shield-check-line",
        "text": "Фиксированная цена в договоре"
      },
      {
        "icon": "ri-customer-service-2-line",
        "text": "Поддержка после запуска"
      }
    ],
    "formTitle": "Обсудить интеграции",
    "formSubtitle": "Расскажите, какие системы нужно связать с amoCRM — подберём схему и цену"
  },
  "detail": {
    "cardLink": "Подробнее",
    "orderCta": "Заказать интеграцию",
    "allCta": "Все интеграции",
    "benefitsTitle": "Что вы получите",
    "benefits": [
      "Заявки и данные сразу в карточке сделки",
      "Источник и ответственный заполняются автоматически",
      "Настройку под ваши процессы, а не «как у всех»",
      "Обучение команды и инструкции"
    ],
    "industriesTitle": "Для каких отраслей",
    "relatedTitle": "Смежные интеграции",
    "faqTitle": "Частые вопросы",
    "leadTitleTemplate": "Подключим **{{title}}** к вашей amoCRM",
    "leadText": "Оставьте заявку — уточним детали, предложим схему интеграции и назовём финальную стоимость. Работаем по всей России, подключение удалённо.",
    "formTitle": "Заявка на интеграцию",
    "formSubtitleTemplate": "Настроим «{{title}}» под ваши процессы",
    "prevLabel": "Предыдущая",
    "nextLabel": "Следующая",
    "othersTitleTemplate": "Другие интеграции в категории «{{category}}»",
    "allLinkTemplate": "Все {{count}} интеграций",
    "priceLabel": "Цена",
    "durationLabel": "Срок",
    "guaranteeLabel": "Гарантия в договоре",
    "responseTime": "Ответим в течение 15 минут",
    "headingRule": {
      "alreadyIntegratedPrefix": "Интеграция с",
      "integratedReplacement": "Интеграция amoCRM с",
      "containsMarker": "amoCRM",
      "defaultTemplate": "{{title}} и amoCRM"
    }
  }
}
